import { init, Models, RematchDispatch, RematchRootState } from "@rematch/core"
import persistPlugin from '@rematch/persist';
import storage from "redux-persist/lib/storage";
import immerPlugin from "@rematch/immer";

import { onboard } from './onboard.store';

// import_model

const persistConfig = {
    key: 'cadastromei-persistor',
    storage,
}

export const store = init<RootModel>({ 
    models: { 
        onboard,
    }, 
    plugins: [persistPlugin(persistConfig), immerPlugin()],
});

export interface RootModel extends Models<RootModel> {
    // type_model
    onboard: typeof onboard,
};

export type Store = typeof store
export type Dispatch = RematchDispatch<RootModel>
export type RootState = RematchRootState<RootModel>